export * from "./tanya/tanyaService";
export * from "./packages/packageService";
export * from "./auth/authService";
export * from "./payments/packagePaymentService";
export * from "./sitemap/sitemapService";
export { selectSlots, getCoursesWithBatches } from "./slot-selection/slotSelectionService";
export * from "./payment/paymentService";
